import * as React from 'react';
import { Section } from 'ui/shared/Section';
import { AlarmListView } from './AlarmListView';

export const AlarmListSection = () =>
    <Section
        titleKey="38"
    >
        <AlarmListView/>
    </Section>
;



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/sidePanel/AlarmListSection.tsx